// src/components/common/Alert.js
import React from 'react';
import { useAlert } from '../../hooks/useAlert';

const Alert = () => {
    // --- THE FIX ---
    // This now correctly destructures the 'alert' object from the context.
    const { alert } = useAlert();

    // If there is no alert object, we render nothing.
    if (!alert) {
        return null;
    }

    // Determine the background color based on the alert type.
    const bgColor = alert.type === 'error' ? 'bg-red-500' : 'bg-green-500';

    return (
        <div className={`fixed top-5 right-5 p-4 rounded-md shadow-lg text-white z-50 ${bgColor}`}>
            {alert.msg}
        </div>
    );
};

export default Alert;
